import http from '../http';
import { version } from '../version';
const prefix = `${version}/partnerDocEmail`;

export async function insertPartnerDocEmail(param) {
    return http.post(prefix + `/insertPartnerDocEmail`, param);
}

export async function updatePartnerDocEmail(param) {
    return http.put(prefix + `/updatePartnerDocEmail`, param);
}

export async function deletePartnerDocEmail(param) {
    return http.delete(prefix + `/deletePartnerDocEmail?idx=${param}`);
}

export async function partnerDocEmailList(param) {
    return http.get(prefix + `/partnerDocEmailList?pt_cd=${param}`);
}
